import { FormControl, FormControlLabel, FormHelperText, styled, Switch } from '@mui/material'
import { ChangeEvent } from 'react'

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 14,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 10,
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(14px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#402080',
      },
      '&.Mui-disabled': {
        color: '#fff',
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.5,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 10,
    height: 10,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#69728280',
    boxSizing: 'border-box',
  },
}))

const MUISwitch: React.FC<{
  label?: string
  checked?: boolean
  required?: boolean
  name?: string
  error?: any
  placement?: 'start' | 'end' | 'top' | 'bottom'
  labelStyle?: React.CSSProperties
  disabled?: boolean
  labelClassName?: string
  onChange?: (evt: ChangeEvent) => void
  noMargin?: boolean
}> = ({
  label,
  checked = false,
  required = false,
  onChange = () => {
    return
  },
  name = '',
  error = {},
  placement = 'end',
  labelStyle,
  disabled = false,
  labelClassName = '',
  noMargin = false,
}: {
  label?: string
  checked?: boolean
  required?: boolean
  name?: string
  error?: any
  placement?: 'start' | 'end' | 'top' | 'bottom'
  onChange?: (evt: ChangeEvent) => void
  labelStyle?: React.CSSProperties
  disabled?: boolean
  labelClassName?: string
  noMargin?: boolean
}) => {
  return (
    <FormControl sx={{ marginRight: noMargin ? '0px' : '11px' }}>
      <FormControlLabel
        disabled={disabled}
        control={
          <AntSwitch
            inputProps={{
              id: label,
              name: label,
              'aria-label': label,
            }}
            checked={checked}
            onChange={onChange}
            onClick={(e) => e.stopPropagation()}
            data-testid={`${label?.toLowerCase()} ${checked ? 'on' : 'off'}`}
          />
        }
        labelPlacement={placement}
        label={
          <span style={labelStyle} className={labelClassName}>
            <span
              style={{ color: checked ? '#402080' : '#69728280', opacity: disabled ? '0.5' : '1' }}
            >
              {label}
            </span>
            {required && <span style={{ color: '#D4351C' }}>*</span>}
          </span>
        }
        componentsProps={{
          typography: {
            onClick: (e: React.MouseEvent) => {
              e.preventDefault()
              e.stopPropagation()
            },
          },
        }}
      />
      {!!error?.[name] && <FormHelperText>{error?.[name]?.message}</FormHelperText>}
    </FormControl>
  )
}

export default MUISwitch
